import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "../../global/config/config.token";
import { AppConfig } from "../../global/config/app.config";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class JFCService {
    constructor(private httpClient: HttpClient,
                @Inject(APP_CONFIG) private config: AppConfig)
    { }

    getAllocationSettings = (campaignId: number, childCampaignId: number): Observable<Array<any>> => {
        return this.httpClient.get<any[]>(`${this.config.apiUrl}jfc/allocation-settings?campaignId=${campaignId}&childCampaignId=${childCampaignId}`, { withCredentials: true });
    }

    saveAllocationSetting = (allocationSetting: any): Observable<any> => {
        return this.httpClient.post(`${this.config.apiUrl}jfc/save-allocation-setting`, allocationSetting, { withCredentials: true });
    }

    reorderAllocationSetting = (allocationSettings: any[]): Observable<any> => {
        return this.httpClient.post(`${this.config.apiUrl}jfc/reorder-allocation-settings`, allocationSettings, { withCredentials: true });
    }

    deleteAllocationSetting = (allocationSetting: any): Observable<any> => {
        return this.httpClient.post(`${this.config.apiUrl}jfc/delete-allocation-setting`, allocationSetting, { withCredentials: true });
    }

    getDistributionsJobReport = (formData: FormData): Observable<any> => {
        return this.httpClient.post(`${this.config.apiUrl}jfc/get-distributions-job-report`, formData, { withCredentials: true });
    }

    downloadFile = (formData: FormData): Observable<any> => {
        return this.httpClient.post(`${this.config.apiUrl}jfc/download-file`,
            formData,
            { 
                responseType: 'blob',
                withCredentials: true 
            });
    }
}